import { Autocomplete, Box, IconButton ,TextField} from "@mui/material"
import { NewRemoveRoundIcon } from "../../../../../../core/global/GMicons"
import { IOSSwitch } from "../../../../../../core/global/forms/CstmToggle"
import { useMemo } from "react"

export const TFields = ({ match, allUsers, teamForm, setTeamForm, teamid }) => {
    const handleInputTeam = (e, id, indx, type) => {
        const {name, value, checked} = e.target
        let fdata = [...teamForm]
        if (type === 'member') {
            teamForm[indx][type] = id
        }else{
            teamForm[indx][name] = name === 'team_name' ? value : (checked ? 1 : 0)
        }
        setTeamForm(fdata)
    }
    const handleRemoveRow = (e, index) => {
        let data = [...teamForm]
        data.splice(index, 1)
        data = data.map((v,k) => ({...v, team_number:`TEAM-00000000${teamid + k + 1}`}))
        setTeamForm(data)
    }
    const sortedUsers = useMemo(() => {
        return [...allUsers].sort((a, b) =>
            a.uname.localeCompare(b.uname, undefined, { sensitivity: "base" })
        );
        }, [allUsers]);

    return (
            teamForm.map((v,k) => (
                <Box key={k} width="100%" p={2} display="flex" bgcolor="#FFFFFF" mt={2} borderRadius="10px" alignItems="center" gap={1}>
                    <Box width="100%" display="block" bgcolor="#FFFFFF" alignItems="center" >
                            <Box width="100%" display="block" flexDirection="row" justifyContent="space-between">
                                <Box  width="100%" fontSize="14px" fontWeight={600} >
                                    <Box display='flex' justifyContent='space-between'>
                                        <Box  mb="8px" mt="10px">Team Number *</Box>
                                            {
                                                teamForm.length > 1 &&
                                                    <Box sx={{display:'flex', justifyContent:'right'}}>
                                                        <IconButton variant="contained" sx={{ height: 30, width: 30, bgcolor: '#D8D5D5', '&:hover':{ backgroundColor: '#1B984F' }}} onClick={(e) => handleRemoveRow (e)}>
                                                            <NewRemoveRoundIcon  />
                                                        </IconButton>
                                                    </Box>
                                            }  
                                    </Box>
                                    <TextField  fullWidth disabled name="team_number" sx={{"& .MuiOutlinedInput-root": {height: "40px"},}} value={v.team_number}/>
                                </Box>

                                <Box  width="100%" fontSize="14px" fontWeight={600}  >
                                    <Box  mb="8px" mt="10px">Team Name *</Box>
                                    <TextField InputProps={{fontSize: 14}} fullWidth name="team_name" sx={{"& .MuiOutlinedInput-root": {height: "40px"},}}  error={Boolean(v.error)} helperText={v.error} value={v.team_name} onChange={(e) => handleInputTeam(e, v.id, k) }/>
                                </Box>
                            </Box>
                            
                            <Box  width="100%" fontSize="14px" fontWeight={600} >
                                    <Box mb="8px" mt="10px">Team Member *</Box>
                                <Autocomplete 
                                    disablePortal
                                    blurOnSelect
                                    name="member"
                                    multiple
                                    noOptionsText="No Result"
                                    disableCloseOnSelect
                                    autoHighlight={true}
                                    options={sortedUsers}
                                    // options={allUsers}
                                    getOptionLabel={(data) => (data.uname)}
                                    value={teamForm[k].member?.length ? allUsers.filter((user) => teamForm[k].member.includes(user.id)) : []}
                                    onChange={(e, value) => {
                                        const selectedIds = value.map((option) => option.id)
                                        handleInputTeam(e, selectedIds, k, 'member')
                                    }}
                                    renderInput={(params) => (
                                        <TextField fullWidth   {...params} inputProps={{...params.inputProps,autoComplete: 'off' ,sx:{ height: 12, p:0 ,'& input':{height:"10px",lineHeight:'12px', p:'0 12px' } }}} />
                                    )}
                                />
                            </Box>
                            {
                                match.params === 'update' &&
                                    <Box width="100%" display="flex" justifyContent="flex-end" gap={1} p="16px 16px 0px 16px">
                                        <IOSSwitch name="active" value={teamForm.active} checked={teamForm[k].active === 1 ? true : false} onClick={(e) => handleInputTeam (e, v.id, k,'active')}/>
                                        <Box>{v.active === 1 ? 'Active' : 'Inactive'}</Box>
                                    </Box>
                            }  
                    </Box>   
                </Box>
            ))
            
    
    )
}